import { Component } from "react";
import { UI, BTN } from "../constants/tokens";

// ─── A screen that loads on demand, and fails to (sprint 13, 6.2) ───────────
// The Academy arrives as its own file. After a deploy, a tab opened before it
// asks for a file that no longer exists; React.lazy then throws, and without
// a boundary the whole app would unmount to a white screen. This catches it
// for that screen only, says so, and offers a reload (which fetches the new
// files).
export default class ChunkBoundary extends Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error("[ChunkBoundary]", error?.message || error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div dir="rtl" role="alert" style={{ padding: "20px 16px", textAlign: "center", color: UI.text.secondary, fontSize: 14, lineHeight: 1.7 }}>
        המסך לא נטען. ייתכן שהאפליקציה עודכנה מאז שנפתחה.
        <div style={{ marginTop: 12 }}>
          <button onClick={() => window.location.reload()} style={{ ...BTN.secondary, minHeight: 44, padding: "10px 18px" }}>טען מחדש</button>
        </div>
      </div>
    );
  }
}
